<div class="breadcrumbs">
  <div class="content-wrapper">
    <div class="breadcrumbs-container">
      <a [routerLink]="'/realizacje'" class="breadcrumbs-link-home">Strona główna</a> &raquo; <a [routerLink]="'/realizacje'" class="breadcrumbs-portfolio">Realizacje</a> &raquo; <span>Szczegóły realizacji</span>
    </div>
  </div>
</div>

<main class="portfolio-item-page">
  @if (currentItem) {
    <div class="content-wrapper">
      <div class="portfolio-nav-bar-mobile">
        @if (newerItem) {
          <a [routerLink]="['/realizacje', newerItem.slug]" class="portfolio-nav-btn portfolio-item-page-link-prev-item">
            <i class="fa-sharp fa-regular fa-chevron-left"></i>
            Poprzednia realizacja
          </a>
        }
        <span></span>
        @if (olderItem) {
          <a [routerLink]="['/realizacje', olderItem.slug]" class="portfolio-nav-btn portfolio-item-page-link-next-item">
            Następna realizacja
            <i class="fa-sharp fa-regular fa-chevron-right"></i>
          </a>
        }
      </div>

      @if (newerItem) {
        <a [routerLink]="['/realizacje', newerItem.slug]" [attr.aria-label]="'Poprzednia realizacja'" class="mp-btn tw-icon-only tw-primary portfolio-nav-prev portfolio-item-page-link-prev-item">
          <i class="fa-sharp fa-regular fa-chevron-left"></i>
        </a>
      }
      @if (olderItem) {
        <a [routerLink]="['/realizacje', olderItem.slug]" [attr.aria-label]="'Następna realizacja'" class="mp-btn tw-icon-only tw-primary portfolio-nav-next portfolio-item-page-link-next-item">
          <i class="fa-sharp fa-regular fa-chevron-right"></i>
        </a>
      }

      <div class="portfolio-item-details">
        <div class="portfolio-item-header">
          <h3 class="portfolio-item-title">{{ currentItem.title }}</h3>
        </div>

        <div class="portfolio-item-body">
          <div class="portfolio-item-gallery">
            <div class="portfolio-item-images">
              @for (image of currentItem.images; track image._id) {
                <img [src]="image.imageUrl" class="portfolio-item-image" fetchpriority="high" [alt]="'Zdjęcie realizacji'" [class.active]="activeImageId === image._id" />
              }
            </div>

            <div class="portfolio-item-thumbnails">
              @for (image of currentItem.images; track image._id) {
                <button
                  class="portfolio-item-thumbnail"
                  type="button"
                  [class.active]="activeImageId === image._id"
                  [attr.aria-label]="'Zobacz zdjęcie'"
                  [style.background-image]="'url(' + image.thumbnailUrl + ')'"
                  (click)="setActiveImageId(image._id)"
                ></button>
              }
            </div>
          </div>

          <div class="portfolio-item-data">
            <div class="portfolio-item-data-row">
              <label>Lokalizacja:</label>
              <span>{{ currentItem.location }}</span>
            </div>
            <div class="portfolio-item-data-row">
              <label>Opis:</label>
              <span>{{ currentItem.description }}</span>
            </div>
            <div class="portfolio-item-data-row">
              <label>Wykorzystane dekory:</label>
              <span [innerHTML]="currentItem.decors.join('<br>')"></span>
            </div>
            <div class="portfolio-item-data-row">
              <label>Dodatkowe informacje:</label>
              <span [innerHTML]="currentItem.fittings.join('<br>')"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</main>
